import { Component, OnInit, NgZone, ViewChild, OnDestroy } from '@angular/core';
import { Store, select } from '@ngrx/store';
import { Observable, Subscription } from 'rxjs';
import { Pagination } from 'src/app/models/pagination.model';
import { Candidate } from 'src/app/models/candidate.model';
import { UtilsService } from 'src/app/services/utils.service';
import { HistoryService } from 'src/app/services/history.service';
import { ActivatedRoute, Router } from '@angular/router';
import { fromHistoryInvitations } from 'src/app/reducers/history-invitations.reducer';
import { Invitation } from 'src/app/models/invitation.model';
import { resetHistoryInvitations, setHistoryInvitations } from 'src/app/actions/history-invitations.actions';
import { InvitationService } from 'src/app/services/invitation.service';
import { fromConsultant } from 'src/app/reducers/consultant.reducer';
import { Test } from 'src/app/models/test.model';
import { distinctUntilKeyChanged, take } from 'rxjs/operators';
import { Consultant } from 'src/app/models/consultant.model';
import { AppConfig } from 'src/app/helpers/app.config';
import { TestService } from 'src/app/services/test.service';
import { ReportService } from 'src/app/services/report.service';

@Component({
  selector: 'ct-history',
  templateUrl: './history.component.html',
  styleUrls: ['./history.component.scss']
})
export class HistoryCandidatesComponent implements OnInit, OnDestroy {

  consultant$: Observable<Consultant>;
  historyInvitations$: Observable<Pagination<Invitation>>;

  consultantSubscription: Subscription;

  // Id del candidato que llega por querystring
  candidateId: string;
  candidate: Candidate;
  newTestFromHistoric: Test;
  HCC: number[];
  consultant: Consultant;

  constructor(
    private store: Store,
    private ngZone: NgZone,
    public utilsService: UtilsService,
    private historyService: HistoryService,
    private activatedRoute: ActivatedRoute,
    private invitationService: InvitationService,
    private testService: TestService,
    private reportService: ReportService,
  ) { }

  ngOnInit(): void {
    this.store.dispatch(resetHistoryInvitations());
    this.consultant$ = this.store.pipe(select(fromConsultant.selectConsultantState));
    this.historyInvitations$ = this.store.pipe(select(fromHistoryInvitations.selectHistoryInvitationsState));

    this.candidateId = this.activatedRoute.snapshot.paramMap.get('candidateId');
    this.HCC = AppConfig.settings.OFFICES_WITH_PROJECTS.split(',').map(officeId => Number(officeId));

    this.getHistory(1);
  }

  getHistory(page) {
    this.consultantSubscription = this.consultant$.pipe(distinctUntilKeyChanged('office')).subscribe(consultant => {
      this.consultant = consultant;
      this.ngZone.run(() => {
        this.historyService.getById(this.candidateId, page, consultant.office.id, consultant.client.id).subscribe(historyInvitations => {
          this.store.dispatch(setHistoryInvitations(historyInvitations));
          if (historyInvitations?.data.length > 0) {
            this.candidate = historyInvitations?.data?.[0].candidate;
          } else {
            this.utilsService.goBack();
          }
        }, error => {
          this.utilsService.toast('error', 'CannotGetHistory', true, this.utilsService.getNacsData({endpoint: 'GET' + AppConfig.settings.API + ' /tests', body: {candidateId: this.candidateId, page: page, consultantOfficeId: consultant.office.id}, error: {errorType: error.errorType, errorCode: error.errorCode, message: error.message}}))
        });
      });
    });
  }

  sendReminder(invitation: Invitation) {
    this.store.pipe(take(1), select(fromConsultant.selectConsultantState)).subscribe(consultant => {
      this.invitationService.sendReminder({
        id: [invitation.id]
      }).subscribe(result => {
        this.utilsService.toast('success', 'ReminderSent');
        this.ngOnInit();
      }, error => {
        this.utilsService.toast('error', 'CannotSendReminder', true, this.utilsService.getNacsData({endpoint: 'PUT' + AppConfig.settings.API + '/tests/send/reminder?origin=ct', body: {id: [invitation.id]}, error: {errorType: error.errorType, errorCode: error.errorCode, message: error.message}}));
      });
    });
  }

  ngOnDestroy(): void {
    if (this.consultantSubscription) {
      this.consultantSubscription.unsubscribe();
    }
  }

  // Monta el enlace de la home del candidato de los test
  async copyCandidateHomeLink(token: string) {
    let urlToken = '';
    try {
      if (token !== undefined) {
        this.utilsService.toast('success', 'INVITESCOPY');
        urlToken = this.utilsService.getHomeLink(token);

        if (navigator.clipboard !== undefined) {
          await navigator.clipboard.writeText(urlToken);
        }
      }
    } catch (error) {
      console.error(error);
    }

  }

  getEvalualiaReport(testId, randstadCandidate, invitationId, officeId) {
    const reportParams = {
      reportTypeId: 2,
      testId: testId,
      languageId: 1,
      origin: 'ct',
      randstadCandidate: randstadCandidate,
      invitationId: invitationId,
      officeId: officeId,
    };

    this.reportService.generateReportToken(reportParams).subscribe(res => {
      this.reportService.getEvalualiaWebReport(res.token, 1);
    }, error => this.utilsService.toast('error', 'Unexpected', true, this.utilsService.getNacsData({endpoint: 'GET' + AppConfig.settings.API + '/report/token', body: reportParams, error: {errorType: error.errorType, errorCode: error.errorCode, message: error.message}})));
  }
}
